import { render, staticRenderFns } from "./VendorsSelector.vue?vue&type=template&id=59ac0696&"
import script from "./VendorsSelector.vue?vue&type=script&lang=js&"
export * from "./VendorsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports